import type { ReactNode } from 'react'
import { observer } from 'mobx-react-lite'
import { useFeatureToggle } from 'app/hooks/useFeatureToggle'

export const Feature = observer(function Feature(props: { name?: string; neg?: boolean; children: ReactNode }) {
  // Hooks must run unconditionally, so we always call the hook. An empty name is
  // treated as "no gate": the hook returns false for it, and we override to
  // `true` below when `name` is undefined.
  const toggleEnabled = useFeatureToggle(props.name ?? ``)
  const enabled = props.name === undefined ? true : toggleEnabled
  const shouldRender = props.neg ? !enabled : enabled

  return shouldRender ? <>{props.children}</> : <></>
})
